import { Bluex, Success, typography, Warning } from "@bonusx-global/bx-design-system";
import type { Components, CSSInterpolation, Theme } from "@mui/material";

type SnackbarAlertSeverity = "error" | "success" | "warning" | "info";

const MuiAlertOverridesMapper: Record<SnackbarAlertSeverity, CSSInterpolation> = {
  error: {
    // NOTE: This needs to be added to the theme palette
    backgroundColor: `#D32F2F`,
    color: "#fff",
    fontFamily: typography.fontFamily,
  },
  success: {
    backgroundColor: Success.main,
    color: Success.contrastText,
    fontFamily: typography.fontFamily,
  },
  warning: {
    backgroundColor: Warning.main,
    color: Warning.contrastText,
    fontFamily: typography.fontFamily,
  },
  info: {
    backgroundColor: Bluex["600"],
    color: "#fff",
    fontFamily: typography.fontFamily,
  },
};

function isSnackbarAlertSeverity(severity: string): severity is SnackbarAlertSeverity {
  return severity in MuiAlertOverridesMapper;
}

export const MuiAlertOverrides: NonNullable<Components<Theme>["MuiAlert"]> = {
  styleOverrides: {
    root: ({ ownerState }) => {
      const severity = ownerState.severity;
      if (!severity || !isSnackbarAlertSeverity(severity)) return undefined;
      return MuiAlertOverridesMapper[severity];
    },
    action: {
      "& button": {
        color: "inherit",
      },
    },
  },
};
